import React from 'react';

import { Card, CardContent, CardHeader, Divider } from '@mui/material';

type BaseCardProps = {
  title: string;
  subheader: string;
  children: React.ReactNode;
};

export default function InventoryCard({ title, subheader, children }: BaseCardProps) {
  return (
    <Card>
      <CardHeader title={title} subheader={subheader} />
      <Divider />
      <CardContent sx={{ px: 0 }}>{children}</CardContent>
    </Card>
  );
}
